export default "__VITE_ASSET__$oBZ5$7N__"